import _ from 'lodash'
import styled, { css } from 'styled-components'
import { useContext } from 'react'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'

import { Box } from '../Box'
import { Tag } from '../Tag'
import { Icon } from '../Icons'

const NoScrollbarBox = styled(Box)`
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {
    display: none;
  }

  .react-horizontal-scrolling-menu--scroll-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`

const StyledLinkDiv = styled.div<{ visible: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 7px;
  padding-right: 14px;
  ${({ visible }) =>
    !visible &&
    css`
      opacity: 0;
    `}
`

const StyledLeftArrowLinkDiv = styled(StyledLinkDiv)<{ visible: boolean }>`
  padding: 0 14px 0 7px;
`

const StyledRightArrowLinkDiv = styled(StyledLinkDiv)<{ visible: boolean }>`
  padding: 0 7px 0 14px;
`

const StyledIcon = styled(Icon)`
  vertical-align: middle;
`

const RotatedStyledIcon = styled(StyledIcon)`
  transform: rotate(180deg);
`

export type FiltersMetaRowProps = {
  filters: {
    key: string
    label: string
    value: any
  }[]
  onClose?: (filterKey: string) => void
}

export const FiltersMetaRow = ({ filters, onClose }: FiltersMetaRowProps) => {
  return (
    <NoScrollbarBox>
      <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
        {filters.map(filter => (
          <Tag
            key={filter.key}
            closable
            text={`${filter.label}: ${_.toString(filter.value)}`}
            onClose={() => onClose && onClose(filter.key)}
          />
        ))}
      </ScrollMenu>
    </NoScrollbarBox>
  )
}

const LeftArrow = () => {
  const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext)
  return (
    <StyledLeftArrowLinkDiv visible={!isFirstItemVisible}>
      <a onClick={() => scrollPrev()}>
        <RotatedStyledIcon type="ArrowRightBlue" />
      </a>
    </StyledLeftArrowLinkDiv>
  )
}

const RightArrow = () => {
  const { isLastItemVisible, scrollNext } = useContext(VisibilityContext)
  return (
    <StyledRightArrowLinkDiv visible={!isLastItemVisible}>
      <a onClick={() => scrollNext()}>
        <StyledIcon type="ArrowRightBlue" />
      </a>
    </StyledRightArrowLinkDiv>
  )
}
